import { combineReducers } from 'redux';
import fundQuotaReducer from './containers/QuotaHistoryTable/fundQuota';
import exportQuotaReducer from './containers/QuotaHistoryTable/exportQuota';
import exportPortfolioReducer from './containers/PortfolioCompositionTable/exportPortfolio';
import portfolioCompositionReducer from './containers/PortfolioCompositionTable/portfolioComposition';

const reducers = combineReducers({
  fundQuotaReducer,
  exportQuotaReducer,
  exportPortfolioReducer,
  portfolioCompositionReducer,
});

export default reducers;
